import React from 'react'
import PropTypes from 'prop-types'
import ProjectUserListItem from "./ProjectUserListItem";

const ProjectUsers = ({data, canViewFinances}) => {

    return (
        <div className="d-flex flex-column">
            {data && data
                .sort((a, b) => b.total_minutes_worked - a.total_minutes_worked)
                .map(user => <ProjectUserListItem canViewFinances={canViewFinances} {...user}/>)}
        </div>
    )

}

ProjectUsers.propTypes = {
    data: PropTypes.array,
    canViewFinances: PropTypes.bool.isRequired,
}

export default ProjectUsers